import { IServicesLayoutProps } from '../../types';
import * as styles from '../../ServicesLayout.css';
import * as React from 'react';

export const ServicesLayoutMobile = ({ services, competitors, error }: IServicesLayoutProps) => (
  <div className={styles.container}>
    {services}
    {error && <div className={styles['error']}>{error}</div>}
    <div className={styles.competitors}>{competitors}</div>
  </div>
);
